<template>
  <div class="col-xl-3 col-sm-6 mod-container">
    <div class="drag-indicator">
      <i class='bx bxs-grid'></i>
    </div>
    <div class="card border shadow-none me-2">
      <div class="card-body p-3">
        <div class="d-flex mb-2 pb-1 border-bottom">
          <div class="avatar flex-shrink-0 me-2">
            <img
              :src="mopModule.logo"
              alt=""
              @error="
                (e) =>
                  (e.target.src = require('@/assets/images/img-placeholder.png'))
              "
              class="img-thumbnail border-0"
            />
          </div>
          <div class="flex-grow-1r align-self-center overflow-hidden">
            <h5 class="mb-0 text-truncate">
              <b-link
                @click="() => this.$emit('edit', mopModule)"
                class="text-primary font-size-14 fw-bold"
              >
                {{ mopModule.displayName }}</b-link
              >
            </h5>
            <p class="small">{{mopModule.moduleName}}</p>
          </div>
        </div>

        <b-row>
          <b-col>
            <div class="mb-0 text-dark small fw-bold mb-1">
              Status: <span :class="{'text-success':mopStatus == 'Active', 'text-danger':mopStatus == 'Inactive'}">{{ mopStatus }}</span>
            </div>
            <div class="mb-0 text-dark small fw-bold" v-if="mopModule.rateType == 'mdr'">MDR: {{ mopModule.mdrPercentage }}%</div>
            <div class="mb-0 text-dark small fw-bold" v-if="mopModule.rateType == 'rebate'">Rebate: {{ mopModule.rebatePercentage }}%</div>
          </b-col>
          <b-col class="d-flex flex-row-reverse">
            <toggle-button
              @change="() => this.$emit('toggleStatus', mopModule)"
              v-model="mopModuleStatus"
              color="#e73092"
              :sync="true"
              :disabled="mopModule.scheduleStatus.length > 0 && mopModule.scheduleStatus == 'Ongoing'"
            />
          </b-col>
          <b-col sm="12">
            <div class="mb-0 text-dark small fw-bold" v-if="mopModule.scheduleStatus.length > 0">
              MOP Schedule Status: 
              <span :class="{
                'text-warning':mopModule.scheduleStatus == 'Ongoing',
                'text-success':mopModule.scheduleStatus == 'Done',
                'text-disabled':mopModule.scheduleStatus == 'Waiting'
              }">
                {{ mopModule.scheduleStatus}}
              </span>
            </div>
            <div class="mb-0 text-dark small fw-bold" v-else>&nbsp;</div>
          </b-col>
        </b-row>
      </div>
      <!-- end card body -->
      <div class="btn-group btn-icon" role="group">
        <button
        class="btn btn-outline-light"
          @click="() => this.$emit('delete', mopModule)"
        >
          <i class="text-danger mdi mdi-delete"></i>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { ToggleButton } from 'vue-js-toggle-button';

export default {
  props: ["mopModule"],
  components: {
    ToggleButton
  },
  computed: {
    mopModuleStatus: {
      get(){
        if(this.mopModule.mdStatus == 'a'){
          return true;
        } else {
          return false;
        }
      },
      set(value){
        if(value){
          this.mopModule.mdStatus = 'a';
        } else {
          this.mopModule.mdStatus = 'i';
        }
      }
    },
    mopStatus: {
      get(){
        if(this.mopModule.mdStatus == 'a' && this.mopModule.mpStatus == 'a'){
          return 'Active';
        } else {
          return 'Inactive';
        }
      }
    }
  }
};
</script>

<style scoped>
.drag-indicator {
  position: absolute;
  top: 5px;
  right: 15px;
  z-index: 10;
  font-size: 20px;
  cursor: grab;
}

.mod-container {
  position: relative;
  cursor: grab;
}
</style>